import React, { useContext } from 'react';
import { faTrashAlt, faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../../../../../../context';
import { DaylightContext } from '../../../../../DaylightCodeMapper';
import classNames from 'classnames';
import './styles.css';

const DeleteMappingButton = ({ code, mapping, isUpdating }) => {
    const dispatch = useDispatch();
    const { practiceId, partnerId } = useContext(DaylightContext);

    let buttonIcon = faRedoAlt;
    if (!isUpdating) {
        buttonIcon = faTrashAlt;
    }

    const deleteMapping = () => {
        dispatch(
            actions.daylight.deleteDaylightMapping(
                practiceId,
                partnerId,
                [],
                code,
                mapping,
                {
                    OldTaxonomyCodeNodeGuid: mapping.taxonomyCodeNodeGuid,
                }
            )
        );
    };

    return (
        <FontAwesomeIcon
            className={classNames('mr-2 delete-mapping pop-hoverable', {
                rotating: isUpdating,
                'fa-disabled': isUpdating,
            })}
            onClick={deleteMapping}
            icon={buttonIcon}
            size="lg"
            title="Delete Mapping"
        />
    );
};

export default DeleteMappingButton;
